const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

export const formatReleaseDate = (date: string, locale: string): string => {
  if (!ISO_DATE.test(date)) {
    return date
  }

  const parsed = new Date(`${date}T12:00:00`)
  if (Number.isNaN(parsed.getTime())) {
    return date
  }

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(parsed)
}
